import { Flex, Tag, Tooltip } from 'antd'
import { LucideIcon } from 'components/LucideIcon'
import { resolvePillTone } from 'features/libra/dashboard/ticketDashboard/pillTone'
import type { Pill } from 'features/libra/dashboard/ticketDashboard/types'
import type { FC } from 'react'
import { memo } from 'react'
import styled from 'styled-components'

const ICON_SIZE = 12

const Dot = styled.span<{ $color: string }>`
  flex-shrink: 0;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`

interface TicketPillProps {
  pill: Pill
}

/** Icons go in the label, not Tag's `icon` slot: Lucide's block-level svg breaks that slot onto two lines. */
const RawTicketPill: FC<TicketPillProps> = ({ pill }) => {
  const { label, tooltip, tone, icon } = pill
  const { tagColor, dotColor } = resolvePillTone(tone)
  const tag = (
    <Tag color={tagColor}>
      {icon || dotColor ? (
        <Flex component='span' align='center' gap={4}>
          {dotColor && <Dot $color={dotColor} />}
          {icon && <LucideIcon name={icon} size={ICON_SIZE} />}
          {label}
        </Flex>
      ) : (
        label
      )}
    </Tag>
  )
  if (!tooltip) return tag
  return <Tooltip title={tooltip}>{tag}</Tooltip>
}

export const TicketPill = memo(RawTicketPill)
